<template>
  <div>
    <!-- Search -->
    <button @click="getEventHandlers">Refresh</button>
    <DataTable
      :rowKeys="['name']"
      :rows="eventHandlers"
      :actions="
        readOnly
          ? [
              {
                name: 'eventHandler',
                label: 'View',
                params: {
                  name: 'eventHandlerName'
                }
              }
            ]
          : [
              {
                name: 'eventHandler',
                label: 'View',
                params: {
                  name: 'eventHandlerName'
                }
              },
              {
                name: 'eventHandlerEdit',
                label: 'Edit',
                params: {
                  name: 'eventHandlerName'
                }
              }
            ]
      "
      :columns="[
        { name: 'name', type: 'text' },
        { name: 'event', type: 'text' },
        { name: 'active', type: 'boolean' },
        { name: 'condition', type: 'text' }
      ]"
    />
    <!-- Pagination -->
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'

export default {
  name: 'EventHandlerList',
  computed: {
    ...mapGetters({
      eventHandlers: 'eventHandlersOrderByNameAsc'
    }),
    ...mapState(['readOnly', 'eventHandlers'])
  },
  methods: mapActions(['getEventHandlers']),
  created() {
    this.getEventHandlers()
  },
  components: {
    DataTable
  }
}
</script>
